import { HeadlineTwo, Paragraph } from 'components/atoms/SectionWrapper.style';
import React, { Component } from 'react';
import styled from 'styled-components';
import { WrapperCounterStyle, HeadlineECounterdit } from './CounterStyles';

// const WrapperCounter = styled.div`
// height: 400px ;
// `

class CounterPV extends Component {
  constructor() {
    super();
    this.state = {
      count: 0,
    };
  }

  counter = (minimum, maximum) => {
    for (let count = minimum; count <= maximum; count++) {
      setTimeout(() => {
        this.setState({ count });
      }, 1500);
    }
  };

  componentDidMount() {
    this.counter(0, 100);
  }
  render() {
    return (
      <WrapperCounterStyle>
        {/* <Border> */}
        {/* <div> */}
        <HeadlineECounterdit id="stats-number">
          {this.state.count}+ <br /> projektów PV
        </HeadlineECounterdit>
        {/* </div> */}
        {/* </Border> */}
      </WrapperCounterStyle>
    );
  }
}

export default CounterPV;
